import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { CategoryStoreService } from '../client/store/category.store.service';

@Injectable()
export class CategoryResolver implements Resolve<boolean> {
    constructor(private categoryStoreService: CategoryStoreService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const categoryId = route.paramMap.get('id');
        return this.categoryStoreService.getCategoryById(categoryId).pipe(
            map((category) => {
                if (!category) {
                    this.categoryStoreService.fetchCategoryById(categoryId);
                }
                return true;
            }),
            first()
        );
    }
}
